import {Component} from '@angular/core';
import {InfoModalService} from 'src/app/core/services/info-modal.service';
import {UtilsService} from 'src/app/core/services/utils.service';
import {CdsIconModule} from "@cds/angular";
import {TranslateModule} from "@ngx-translate/core";
import {ClrModalModule} from "@clr/angular";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-resource-info-modal',
  standalone: true,
  imports: [CommonModule, CdsIconModule, TranslateModule, ClrModalModule],
  templateUrl: './resource-info-modal.component.html',
  styleUrls: ['./resource-info-modal.component.scss']
})
export class ResourceInfoModalComponent {

  constructor(public service: InfoModalService, public utils: UtilsService) { }


}
